import { useNeedsAppUpdate } from 'app/atoms/needs-app-update';
import { images } from 'app/design/images';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { env } from 'app/lib/env';
import { getI18nLanguage } from 'app/lib/language';
import { useUISize } from 'app/utils/web-helpers';
import { WHITE_LABEL } from 'app/../app.config.json';
import { useTranslation } from 'react-i18next';
import { Linking } from 'react-native';

export function DownloadAppSection({ showQrCodes = true }: { showQrCodes?: boolean }) {
  const { t } = useTranslation('login');
  const language = getI18nLanguage();
  const { possibleUrls } = useNeedsAppUpdate();
  const { isLargeUI } = useUISize();
  const qrCodes =
    isLargeUI && showQrCodes
      ? env.IS_PARTAKE
        ? { appStore: images.qr_code_partake_app_store, googlePlay: images.qr_code_partake_google_play }
        : !WHITE_LABEL
          ? { appStore: images.qr_code_partage_club_app_store, googlePlay: images.qr_code_partage_club_google_play }
          : undefined
      : undefined;

  return (
    <Column
      alignItems="center"
      backgroundColor="surface.primary"
      gap="spacing.general.x4"
      paddingBottom={isLargeUI ? 'spacing.general.x8' : 'spacing.general.x4'}
      paddingTop="spacing.general.x4"
    >
      <Text fontSize={18} fontWeight="700">
        {t('downloadApp')}
      </Text>
      <Row gap="spacing.general.x2">
        <Column alignItems="center" gap="spacing.general.x2">
          <Button onPress={() => void Linking.openURL(possibleUrls.ios)} variant="plain">
            <PCImage
              contentFit="contain"
              height={48}
              source={language === 'fr' ? images.guest_app_store_fr : images.app_store_en}
              width={152}
            />
          </Button>
          {qrCodes ? <PCImage contentFit="contain" height={152} source={qrCodes.appStore} width={152} /> : null}
        </Column>
        <Column alignItems="center" gap="spacing.general.x2">
          <Button onPress={() => void Linking.openURL(possibleUrls.android)} variant="plain">
            <PCImage
              contentFit="contain"
              height={48}
              source={language === 'fr' ? images.guest_google_play_fr : images.google_play_en}
              width={162}
            />
          </Button>
          {qrCodes ? <PCImage contentFit="contain" height={152} source={qrCodes.googlePlay} width={152} /> : null}
        </Column>
      </Row>
    </Column>
  );
}
